<template>
	<div class="fragment-wrapper">
		<h2>Mi carrito</h2>
		
		<div v-if="!is_not_logged">
			<div v-if="!render_products.length">
				<p class="text-general text-padding-left">Tu carrito de compras está vacío. Navega por nuestro <a v-link="{ path: '/almacenamiento?page=1' }">Catálogo en Línea</a> para agregarle productos.</p>
			</div>
			<div class="table-responsive">
				<table class="table" v-if="render_products.length">
					<thead>
						<tr>
							<th>Nombre</th>
							<th>Imágen</th>
							<th>Descripción</th>
							<th>Cantidad</th>
							<th>Precio Unitario</th>
							<th>Subtotal</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="product_cart in render_products">
							<td>
								{{ product_cart.product.name }}<br>
							</td>
							<td><img :src="getMainImage(product_cart.product)" alt="Main image"></td>
							<!-- TODO: print the product colors. -->
							<td>
								<p>Tamaño:</p>
								<p><strong>{{ getSize(product_cart) }}</strong></p>
								<p>Color:</p>
								<div class="admin-span-color color-border" :style="`background-color: ${ product_cart.product.color }`"></div>
								<div v-if="product_cart.product.color2" class="admin-span-color color-border" :style="`background-color: ${ product_cart.product.color2 }`"></div>
							</td>
							<td><input class="form-control" type="number" min="1" v-model="product_cart.quantity"/></td>
							<td v-if="!product_cart.variation || product_cart.variation == 'M'">${{ accounting.formatMoney((product_cart.product.price).toFixed(2), '') }}</td>
							<td v-if="!product_cart.variation || product_cart.variation == 'M'">${{ accounting.formatMoney((product_cart.product.price * product_cart.quantity).toFixed(2), '') }}</td>
							<td v-if="product_cart.variation == 'S'">${{ accounting.formatMoney((product_cart.product.price_S).toFixed(2), '') }}</td>
							<td v-if="product_cart.variation == 'S'">${{ accounting.formatMoney((product_cart.product.price_S * product_cart.quantity).toFixed(2), '') }}</td>
							<td v-if="product_cart.variation == 'L'">${{ accounting.formatMoney((product_cart.product.price_L).toFixed(2), '') }}</td>
							<td v-if="product_cart.variation == 'L'">${{ accounting.formatMoney((product_cart.product.price_L * product_cart.quantity).toFixed(2), '') }}</td>
							<td><i class="glyphicon glyphicon-remove pointer" @click="removeProduct(user, product_cart)"></i></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-7" v-if="render_products.length">
				<form class="form-inline form-coupon" @submit="applyCodeShoppingCart">
					<div class="form-group">
						<label for="code">Cupón de descuento</label>
						<input type="text" class="form-control" :class="{ 'has-error': err_promo_code }" v-model="code">
			          <button type="submit" class="btn btn-black btn-responsive">Aplicar</button>
				    </div>
					<div class="form-group" v-if="false">
						<button type="submit" class="btn btn-black btn-lg">Ingresar</button>
					</div>
				</form>
				<div class="info-box">
					<strong>
						¿Dudas al comprar?
					</strong>
					<a class="link-custom">Contáctanos por medio del chat</a>
				</div>
			</div>
			<div class="col-md-5 no-padding-right" v-if="render_products.length">
				<form class="form-horizontal form-payment no-padding-right" role="form" @submit="nextStep">
					<div class="row form-group">
					    <label class="control-label col-sm-3" for="name">Subtotal</label>
					    <div class="col-sm-9">
					      <input type="text" class="form-control" id="subtotal" v-model="render_subtotal" disabled>
					    </div>
				 	</div>
					<div class="row form-group">
						<label class="control-label col-sm-3" for="coupon">Descuento cupón</label>
						<div class="col-sm-9">
						  <input type="text" class="form-control" id="coupon" v-model="render_discount" disabled>
						</div>
					</div>
					<div class="row form-group">
						<label class="control-label form-label-strong col-sm-3" for="total">Total a pagar</label>
						<div class="col-sm-9">
						  <input type="text" class="form-control" id="total" v-model="render_total" disabled>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-sm-9 col-sm-offset-3">
							<button type="submit" class="btn btn-black btn-lg">Proceder a comprar</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!-- TODO: implement if the user is logged don't show this, if is not show it -->
		<shopping-cart-login v-if="is_not_logged"></shopping-cart-login>
	</div>
</template>

<script>
import ShoppingCartLogin from './Shopping-cart-login.vue';
import default_image from '../../images/default.jpg';
import { toast } from '../../scripts/toast';
import accounting from '../../scripts/accounting';
import {
	removeProductShoppingCart,
	updateShoppingCart,
	applyPublicCode,
	resetFedexQuote,
	resetNationalQuote,
	resetAddressShoppingCart
} from '../../store/actions';

export default {
	data () {
		return {
			code: null,
			is_not_logged: false,
			err_promo_code: null,
			image: default_image,
			accounting
		}
	},
	// ---- VUEX ----

	vuex: {
		getters: {
			promo_code: state => state.promo_code,
			user: state => state.current_user,
			allow_continue: state => state.allow_continue,
			shopping_cart: state => {
				let products = state.products;
				let shopping_cart = state.shopping_cart;

				// search the images in the products to append to the products
				// in the shopping cart.
				if (products && shopping_cart.products)
					for (let i = 0; i < products.length; i++) {
						for (let j = 0; j < shopping_cart.products.length; j++) {
							if (products[i].id == shopping_cart.products[j].product_id) {
								shopping_cart.products[j].product.images = products[i].images;
							}
						}
					}

				return shopping_cart;
			}
		},
		actions: {
			removeProductShoppingCart,
			updateShoppingCart,
			applyPublicCode,
			resetFedexQuote,
			resetNationalQuote,
			resetAddressShoppingCart
		}
	},

	// ---- RENDER ----

	computed: {
		render_user() {
			return this.user;
		},

		render_promo () {
			return this.promo_code;
		},

		render_products() {
			if (this.shopping_cart && this.shopping_cart.products) {
				return this.shopping_cart.products;
			}

			return [];
		},

		render_subtotal() {
			let subtotal = 0;

			for (var i = 0, p = this.shopping_cart.products; i < p.length; i++) {
				switch (p[i].variation) {
					case 'S':
						subtotal += p[i].product.price_S * p[i].quantity;
						break;
					case 'L':
						subtotal += p[i].product.price_L * p[i].quantity;
						break;
					default:
						subtotal += p[i].product.price * p[i].quantity;
				}
			}

			return '$ ' + accounting.formatMoney(subtotal.toFixed(2), '');
		},

		render_total() {
			let total = 0;

			for (var i = 0, p = this.shopping_cart.products; i < p.length; i++) {
				switch (p[i].variation) {
					case 'S':
						total += p[i].product.price_S * p[i].quantity;
						break;
					case 'L':
						total += p[i].product.price_L * p[i].quantity;
						break;
					default:
						total += p[i].product.price * p[i].quantity;
				}
			}

			if (this.promo_code.discount) {
				if (this.promo_code.is_percentage == '1') {
					total -= (total * this.promo_code.discount);
				} else {
					total -= this.promo_code.discount;
				}
			}

			if (total < 0) {
				total = 0;
			}

			return '$ ' + accounting.formatMoney(total.toFixed(2), '');
		},

		render_discount() {
			if (this.promo_code.discount) {
				if (this.promo_code.is_percentage == '1') {
					return (this.promo_code.discount * 100) + '%';
				} else {
					return '$' + accounting.formatMoney(this.promo_code.discount, '');
				}
			}

			return '$ 0.00';
		}
	},

	// ---- METHODS ----

	methods: {
		nextStep(e) {
			e.preventDefault();

			for (let i = 0, p = this.shopping_cart.products; i < p.length; i++) {
				if (!p[i].quantity || p[i].quantity < 1) {
					return toast({
						title: 'Carrito de Compras',
						content: 'Alguna cantidad de producto esta vacía o no es valida.'
					});
				}
			}

			if (!this.user.token) {
				return this.is_not_logged = true;
			}

			this.updateShoppingCart(this.user, this.shopping_cart.products);
			this.allow_continue[1] = true;
			$('#address').tab('show');
		},

		applyCodeShoppingCart (e) {
			e.preventDefault();
			let product_has_promo = false;
			
			for (let i = 0, p = this.shopping_cart.products; i < p.length; i++) {
				if (p[i].product.discount_percentage) {
					product_has_promo = true;
				}
			}

			this.err_promo_code = null;
			
			if (!this.code) {
				this.err_promo_code = true;
			}

			this.applyPublicCode(this.user, this.code, product_has_promo);
		},

		getSize (p) {
			switch (p.variation) {
				case 'S':
					return 'Large';
				case 'L':
					return 'Extra Large';
				default:
					return 'Standard';
			}
		},

		getMainImage (product) {
			if (product.images.length) {
				return product.images[0].route
			}

			return this.image;
		},

		removeProduct (user, product) {
			this.resetFedexQuote();
			this.resetNationalQuote();
			this.resetAddressShoppingCart();
			this.removeProductShoppingCart(user, product);
		}
	},

	// ---- LOGIN ----

	components: {
		ShoppingCartLogin,
	}
}
</script>



// WEBPACK FOOTER //
// Shopping-cart-add.vue?2137674e